import { render } from "./premiumCoursewarePlayer.vue?vue&type=template&id=2efbbe30&scoped=true"
import script from "./premiumCoursewarePlayer.vue?vue&type=script&lang=js"
export * from "./premiumCoursewarePlayer.vue?vue&type=script&lang=js"

import "./premiumCoursewarePlayer.vue?vue&type=style&index=0&id=2efbbe30&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efbbe30"]])

export default __exports__